import { createSlice } from '@reduxjs/toolkit';
import {
    meteorologico,
} from '../actions/meteorologico';


export const SensoresReducer = createSlice({
    name: 'meteorologico',
    initialState: {
        homeSort: {
            sortby: "_id",
            order: "desc",
            limit: 4,
            skip: 0
        },
        loading: false,
        sensores: [],
        current: null
    },
    reducers: {
    },
    extraReducers: (builder) => {
        builder
            // GET ARTICLE
            .addCase(meteorologico.pending, (state) => { state.loading = true })
            .addCase(meteorologico.fulfilled, (state, action) => {
                state.loading = false;
                state.current = action.payload
            })
            .addCase(meteorologico.rejected, (state) => { state.loading = false })
    }
})


export default SensoresReducer.reducer;

